import { RecordSourceProxy } from 'relay-runtime';

export function deleteWalletPaymentMethodUpdater(
    store: RecordSourceProxy,
    viewerId: string,
    userId: string,
    paymentMethodToken: string | undefined
): void {
    const viewerProxy = store.get(viewerId);
    if (!viewerProxy) {
        throw new Error('Could not get viewer in deleteWalletPaymentMethodUpdater');
    }
    const buyerProxy = viewerProxy.getLinkedRecord('user', {
        userId,
    });
    if (!buyerProxy) {
        throw new Error('Could not get user in deleteWalletPaymentMethodUpdater');
    }
    const walletProxy = buyerProxy.getLinkedRecord('wallet');
    if (!walletProxy) {
        throw new Error('Could not get user in deleteWalletPaymentMethodUpdater');
    }

    walletProxy.setLinkedRecords(
        walletProxy.getLinkedRecords('paymentMethods')?.filter(proxy => {
            const paymentMethod = proxy.getLinkedRecord('paymentMethod');
            if (!!paymentMethod && paymentMethod.getValue('token') === paymentMethodToken) {
                // this is the payment method we are deleting, remove it from the list
                return false;
            }
            return true;
        }),
        'paymentMethods'
    );
}
